export default ({ theme, legacyTheme }) => ({
  wrapper: {
    display: "inline-flex",
    alignItems: "flex-start"
  },

  tooltip: {
    position: "relative",
    cursor: "pointer",
    display: "inline-flex",
    boxSizing: "border-box",
    zIndex: 1,
    "&:focus": {
      outline: "0px"
    }
  },

  symbol: {
    background: "#257886",
    ...legacyTheme.font.bold,
    color: "white",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    textAlign: "center",
    boxSizing: "border-box",
    fontFamily: theme.fonts.swedbankHeadline,
    fontSize: "12px",
    position: "relative"
  },

  open: {
    background: "#31a3ae"
  }
});
